import { render, staticRenderFns } from "./InscripcionFiles.vue?vue&type=template&id=1138e54a"
import script from "./InscripcionFiles.vue?vue&type=script&lang=js"
export * from "./InscripcionFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports